import styled, {css} from 'styled-components';

interface ItemProps {
  readonly status?: string;
  readonly display?: string;
}

export const TextWarning = styled.span<ItemProps>`
  font-size: 10px;
  font-weight: 500;

  ${props => {
    const status = props.status === 'error' ? `color: var(--PrimaryRed);` : props.status === 'success' ?`color: var(--PrimaryGreen);`:'color: #5D6C76;';
    const display = props.display ? `display: ${props.display}` : '';

    return css`
       {
        ${status}
        ${display}
      }
    `;
  }};
`;
